import { render, staticRenderFns } from "./box-shadow-settings.vue?vue&type=template&id=13367bda&scoped=true&"
import script from "./box-shadow-settings.vue?vue&type=script&lang=js&"
export * from "./box-shadow-settings.vue?vue&type=script&lang=js&"
import style0 from "./box-shadow-settings.vue?vue&type=style&index=0&id=13367bda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13367bda",
  null
  
)

export default component.exports